export const ageMethod = "age nearest";
export const gateway = "https://qat-western-shopper-api.link-nonprod.wawanesalife.com";
export const assets = "https://qat-assets.link-nonprod.wawanesalife.com/brokers/western";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJ3ZXN0ZXJuIiwibmFtZSI6Indlc3Rlcm4iLCJpYXQiOjE3ODA1ODAyNjYsImV4cCI6MTkzODM2ODI2Nn0.i53Tt2DpW6ElJPn8oFqnPybSvawVcAsNLMH4FOuB55c";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"qat-western-shopper.link-nonprod.wawanesalife.com": {
		a: {
			accessibilityLink: "https://westernfinancialgroup.ca/Accessibility-Guidelines",
			approve_company: "Link Platform",
			approve_user: "link_western",
			brands: [
				"qat-western-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "western",
			broker_formatted_name: "Western Financial Group",
			email: "myinsurancenow@westernfg.ca",
			environment: "qat",
			environment_id: "qat",
			ftcLink: "https://westernfinancialgroup.ca/Customers-Fair-Treatment",
			g4: "G-2QM64W4BM4",
			introduction: "dOPJxsVASJA",
			layout: "flat",
			logoPosition: "menu",
			map1: "hide",
			map2: "hide",
			map3: "hide",
			map4: "hide",
			menuPhone: "button",
			phone: "(888) 594-3105",
			photo1: "hide",
			photo2: "hide",
			photo3: "hide",
			photo4: "hide",
			privacyLink: "https://westernfinancialgroup.ca/Privacy",
			themeSwitcher: "hide",
			video_link: "dOPJxsVASJA",
			website: "https://westernfinancialgroup.ca/",
			scope: "western#branding#qat-western-shopper.link-nonprod.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "qat-western-shopper.link-nonprod.wawanesalife.com",
		},
		b: {
			accessibilityLink: "https://westernfinancialgroup.ca/Accessibility-Guidelines",
			approve_company: "Link Platform",
			approve_user: "link_western",
			brands: [
				"qat-western-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "western",
			broker_formatted_name: "Western Financial Group",
			email: "myinsurancenow@westernfg.ca",
			environment: "qat",
			environment_id: "qat",
			ftcLink: "https://westernfinancialgroup.ca/Customers-Fair-Treatment",
			g4: "G-2QM64W4BM4",
			introduction: "dOPJxsVASJA",
			layout: "flat",
			logoPosition: "menu",
			map1: "hide",
			map2: "hide",
			map3: "hide",
			map4: "hide",
			menuPhone: "button",
			phone: "(888) 594-3105",
			photo1: "hide",
			photo2: "hide",
			photo3: "hide",
			photo4: "hide",
			privacyLink: "https://westernfinancialgroup.ca/Privacy",
			themeSwitcher: "hide",
			video_link: "dOPJxsVASJA",
			website: "https://westernfinancialgroup.ca/",
			scope: "western#branding#qat-western-shopper.link-nonprod.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "qat-western-shopper.link-nonprod.wawanesalife.com",
		},
	},
};

//updated on Thu Jun 04 2026 13:37:46 GMT+0000 (Coordinated Universal Time)
